export default {
	props: {
		enabled: {
			type: 		Boolean,
			default: 	true
		}
	}
};